export const BackgroundGradient = ({ children }) => {
  return (
    <div className="relative w-full">
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(
            to bottom,
            #fff 0%,
            #fff 20%,
            #fff 45%,
            #5b21b6 65%,
            #0f0728 85%,
            #0a0520 100%
          )`,
        }}
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(circle at 60% 20%, rgba(215, 201, 255, 0.25), transparent 40%),
            radial-gradient(circle at 40% 55%, rgba(120,60,255,0.35), transparent 55%)
          `,
        }}
      />

      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 blur-[100px] right-0 h-[120vh] w-full pointer-events-none"
        style={{
          background: `linear-gradient(
            135deg,
            #0a0520 0%,
            #0a0520 33%,
            #4c1d95 33%,
            #C466FF 66%,
            #7c3aed 66%,
            #191888 100%
          )`,
        }}
      />

      <div className="relative z-10">{children}</div>
    </div>
  )
}
